export const baseCheckoutNavConfig = {
	policies: {
		order: 1,
		path: 'policies',
		titleKey: 'policies',
		prev: null,
		next: 'details'
	},
	details: {
		order: 2,
		path: 'details',
		titleKey: 'your_details',
		prev: 'policies',
		next: 'payment'
	},
	payment: {
		order: 3,
		path: 'payment',
		titleKey: 'payment',
		prev: 'details',
		next: 'confirmation'
	},
	confirmation: {
		order: 4,
		path: 'confirmation',
		titleKey: 'confirmation',
		prev: 'payment',
		next: null
	}
};

